import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { phoneNumbersRoute, accountPhoneNumbersRoute } from 'src/app/app-routing.module';
import { PhoneNumberDetailLinkModel } from '../models/phone-number-detail-link.model';

@Component({
    selector: 'ndt-phone-number-detail-link',
    templateUrl: './phone-number-detail-link.component.html',
    styleUrls: ['../detail-links.scss'],
    standalone: false
})
export class PhoneNumberDetailLinkComponent {
   @Input() phoneNumber: PhoneNumberDetailLinkModel | null;
   @Input() header: string;
   phoneNumbersRoute = accountPhoneNumbersRoute;

}